import { createSelector } from "reselect";
import { assetLeadIdParamSelector } from "selectors/location";

export const assetLeadsSelector = (state) => state.assetLeads;

export const assetLeadSelector = createSelector(
  assetLeadsSelector,
  assetLeadIdParamSelector,
  (assetLeads, assetLeadId) =>
    assetLeads && assetLeads.find((assetLead) => assetLead.id === assetLeadId)
);

export const assetLeadContactsSelector = createSelector(
  assetLeadSelector,
  (state) => state.assetLeadContacts,
  (assetLead, contacts) =>
    contacts.filter((contact) => contact.assetLeadId === (assetLead || {}).id)
);
